// extracted by mini-css-extract-plugin
export default {"goldenAgeItem":"golden-age-item_goldenAgeItem__KC3PW","selected":"golden-age-item_selected__0oaLR"};